import Reflux from 'reflux-react-16'

export default Reflux.createActions([
    'getAccounts',
    'login',
    'switchAccount',
    'loginAsReseller',
    'loginAsCustomer',
    'logout',
    'loggedIn',

    'getAccount',
    'setSelectedBranches',
    'updateUserSettings',
    'getShippingMethods',
    'installLightspeed',
    'uninstallLightspeed',
    'installShopify',
    'installExactOnline',
    'verifyWebshop',
    'createWebshopWebhook',
    'deleteWebshopWebhook',
    'installMollie',
    'getMollieProfiles',

    'getReseller',
    'updateReseller',
    'updateResellerSettings',
    'setTrackTracePhoto',
    'updateCsvColumns',
    'addPartner',
    'addParcelPartner',
    'handlePartnerRequest',
    'removePartner',
    'updatePartnerSettings',
    'getPartners',
    'makeSnelStartVerificationRequests',

    'sendResetPasswordMail',
    'resetPassword',
    'getOwnDetails',
    'updateOwnDetails',
    'changePassword',
    'confirmEmailChange',
    'sendCustomerWelcomeMail',
    'sendUserWelcomeMail',
    'generateMFAKey',
    'mailMFACode',
    'reset2FA',
    'verify2FACode',

    'checkNotifications',
    'updateReadNotifications',

    'getBranding'
])
